<template>
  <div class="orderstatus" :class="{ isLoading: isLoading }">
    <strong>Aktueller Status deiner Bestellung:</strong> {{ lastOrder.status }}<br />
    {{ lastOrder.statusInfo }}

    <ul v-if="lastOrder.timings && lastOrder.timings.Bestellt" class="mt-2">
      <li v-for="(timing, label) in lastOrder.timings" :key="label">
        <strong>{{ label }}:</strong>
        <template v-if="timing">{{ timing }}</template>
        <template v-if="!timing">-</template>
      </li>
    </ul>
  </div>
</template>

<script>

import axios from 'axios'
import endpoints from '../endpoints'
import Pusher from 'pusher-js/with-encryption'

export default {
  name: 'OrderStatus',

  props: {
    type: {
      type: String,
      default: 'order'
    },
    officeOrderId: {
      type: Number,
      default: 0
    },
    officeOrderUid: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      isLoading: false,
      lastOrder: {},
      activePusher: false,
      pusher: false,
      fallBackInterval: null
    }
  },

  created () {
    this.getCurrentStatus()
    this.initPusher()
    this.initFallBackInterval()
  },

  destroyed () {
    this.fallBackInterval = clearInterval(this.fallBackInterval)
    this.pusher.disconnect()
  },

  methods: {
    initPusher (orderId) {
      if (this.activePusher || typeof orderId === 'undefined' || orderId === null) return false
      this.activePusher = true

      this.pusher = new Pusher('4a6b5ab010ed93259f35', {
        cluster: 'eu',
        authEndpoint: endpoints.pusherAuth
      })

      const channel = this.pusher.subscribe('private-order-' + orderId)
      channel.bind('status', (data) => {
        this.getCurrentStatus()
      })
    },

    initFallBackInterval () {
      this.fallBackInterval = window.setInterval(() => {
        this.getCurrentStatus()
      }, 10000)
    },

    getCurrentStatus () {
      this.isLoading = true

      if (this.type === 'officeClient') {
        axios.post(endpoints.officeOrderStatus, {
          officeOrderId: this.officeOrderId,
          officeOrderUid: this.officeOrderUid
        })
          .then(({ data }) => {
            this.lastOrder = data
            this.initPusher(data.orderId)
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        axios.post(endpoints.archive + '/null/true')
          .then(response => {
            this.lastOrder = response.data.orders[0].orders[0]
            this.initPusher(this.lastOrder.id)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .orderstatus {
    transition: all .25s;

    &.isLoading {
      @apply text-grey-dark;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/OrderStatus.vue